import { render, staticRenderFns } from "./BackofficeHonorarioAnestesista.vue?vue&type=template&id=a2afbfb4&scoped=true"
import script from "./BackofficeHonorarioAnestesista.vue?vue&type=script&lang=ts"
export * from "./BackofficeHonorarioAnestesista.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeHonorarioAnestesista.vue?vue&type=style&index=0&id=a2afbfb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2afbfb4",
  null
  
)

export default component.exports